/*
 * @Descripttion:
 * @version: 1.1.0
 * @Date: 2022-11-28 16:49:41
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-01-07 14:05:46
 */
import Vue from 'vue'
// import { notification, Modal } from 'ant-design-vue'
// import store from '@/store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import router from '../router'

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  // baseURL: process.env.VUE_APP_API_BASE_URL_YDAN,
  baseURL: '/',
  withCredentials: true,
  timeout: 10 * 60 * 1000 // 请求超时时间
})

function objToFormData(obj) {
  const form = new FormData()
  Object.keys(obj).forEach(item => {
    form.set(item, obj[item])
  })
  return form
}

// request interceptor
request.interceptors.request.use(config => {
  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token) config.headers['X-Access-Token'] = token
  const types = ['post', 'put', 'delete']
  const { params = {}, method, data } = config
  if (types.includes(method.toLowerCase())) {
    // config.data = objToFormData(params)
    !data ? (config.data = objToFormData(params)) : null
    delete config.params
  }
  return config
})

// response interceptor
request.interceptors.response.use(response => {
  const { code, message } = response.data
  // console.log('code', code, [601, 613, 1070].includes(+code))
  if ([601].includes(code)) {
  //   // 登录超时 携带参数退出 跳转到登录页
    Vue.ls.remove(ACCESS_TOKEN)
    localStorage.removeItem('destiny-admin-userId')
    localStorage.removeItem('destiny-nickname')
    router.push('/login')
  }
  // // 当code返回失败时 抛出错误提示
  // ;+code !== 0 &&
  //   notification['warn']({
  //     message: '警告',
  //     description: message || '服务器未知错误'
  //   })
  return response.data
})

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, request)
  }
}

export default request // 局部使用

export { installer as VueAxios, request as axios } // 全局使用
